type Props = {
  pickupLocation: string
  isSimplified?: boolean
}

const PickupLocation = ({ pickupLocation, isSimplified = false }: Props) => {
  if (!pickupLocation) return <></>

  if (isSimplified)
    return (
      <h3 className="text-bidfta-blue-backdrop-light font-semibold">
        {pickupLocation}
      </h3>
    )

  return (
    <h3 className={'mt-2 break-normal'}>
      <b>Location:</b> {pickupLocation}
    </h3>
  )
}

const pagesWhereComponentIsVisible = ['saved-search', 'account', 'items']

export default PickupLocation
